/**
 * Currency normalization utility for ISO 4217 compliance
 *
 * TDR.Currency enum uses lowercase values (usd, cad, eur, gbp, aed)
 * but ad platforms require uppercase ISO 4217 format (USD, CAD, EUR, GBP, AED)
 */

/**
 * Converts TDR.Currency lowercase values to uppercase ISO 4217 format
 *
 * @param currency - Lowercase currency code from TDR.Currency enum (e.g., 'usd', 'cad')
 * @returns Uppercase ISO 4217 currency code (e.g., 'USD', 'CAD'), or undefined if no currency provided
 *
 * @example
 * toISO4217('usd') // Returns 'USD'
 * toISO4217('cad') // Returns 'CAD'
 * toISO4217(undefined) // Returns undefined
 * toISO4217('') // Returns undefined
 */
export function toISO4217(currency: string | undefined): string | undefined {
  const trimmed = currency?.trim();
  if (!trimmed) {
    return undefined;
  }
  return trimmed.toUpperCase();
}
